import React, { useState } from 'react';
import Tooltip from "rc-tooltip";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './Sidebar.module.css';
import completedImg from "../../../../assets/images/Kitchen/completed.png";
import groupImg from '../../../../assets/images/Kitchen/group.png';
import configImg from '../../../../assets/images/Kitchen/config.png';
import { TMSdiagnostics } from "../../../../assets/images";
import optionIcon from "../../../../assets/images/Fireboard/option.png";
import infoIcon from '../../../../assets/images/Fireboard/menu_buttons/info.png';
import settingsIcon from '../../../../assets/images/Fireboard/menu_buttons/filters.png';
import networkLogsIcon from '../../../../assets/images/Fireboard/settings.png';
import resyncImg from '../../../../assets/images/Fireboard/resync.png';

const icons = [
  {
    name: 'COMPLETED',
    icon: completedImg,
    type: 'completed',
    active: false,
  },
  // {
  //   name: 'ALL DAY',
  //   icon: groupImg,
  //   type: 'allDay',
  //   active: false,
  // },
  // {
  //   name: 'CONFIG',
  //   icon: configImg,
  //   type: 'config',
  //   active: false,
  // },
];

const kitchenSections = [
  {
    id: 0,
    name: 'Expo',
  },
  {
    id: 1,
    name: 'Grill',
  },
  {
    id: 2,
    name: 'Fry',
  },
  {
    id: 3,
    name: 'Dessert',
  },
];

const tooltipOptions = [
  { id: 1, type: 'settings', name: 'Settings', icon: settingsIcon, disabled: false },
  { id: 2, type: 'diagnostics', name: 'Diagnostics', icon: TMSdiagnostics, disabled: false },
  { id: 3, type: 'about', name: 'About', icon: infoIcon, disabled: false },
  { id: 4, type: 'networkLogs', name: 'Network Logs', icon: networkLogsIcon, disabled: false },
];

const Sidebar = (props) => {
  const {
    onKitchenTypeSelect,
    selectedKitchenType,
    handleActions,
    isComplete,
    onClickMenuOption,
    reSync,
  } = props;

  const Category = () => {
    return (
      kitchenSections.map(kt => {
        const selectedStyle = selectedKitchenType === kt.id ? styles.selectedType : {};
        return (
          <div key={kt.id} className={[styles.categoryContainer, selectedStyle].join(' ')} onClick={() => onKitchenTypeSelect(kt)}>
            <span>{kt.name}</span>
            <span>{kt.id}</span>
          </div>
        )
      })
    );
  };

  const Actions = () => {
    return (
      icons.map(it => {
        if (it.type === 'completed' && isComplete) {
          it.active = true;
        } else {
          it.active = false;
        }
        return (
          <div key={it.type} className={styles.imgContainer} style={{ backgroundColor: it.active ? '#fff' : "#000" }} onClick={() => handleActions(it.type)}>
            <img src={it.icon} className={styles.imgStyle} />
            <span className={styles.iconTxt}>{it.name}</span>
          </div>
        )
      })
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.iconsWrapper}>
        <img src={resyncImg} className={styles.imgStyle} onClick={reSync} alt='ReSync' />
        <Menus onClickMenuOption={onClickMenuOption} />
      </div>
      <div className={styles.categoryWrapper}>
        <Category />
      </div>
      <div className={styles.actionWrapper}>
        <Actions {...props} />
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  onKitchenTypeSelect: PropTypes.func,
  selectedKitchenType: PropTypes.any,
  handleActions: PropTypes.func,
  isComplete: PropTypes.bool,
  onClickMenuOption: PropTypes.func,
  reSync: PropTypes.func,
};

Sidebar.defaultProps = {
  onKitchenTypeSelect: () => { },
  handleActions: () => { },
  isComplete: false,
  onClickMenuOption: () => { },
  reSync: () => { },
};

export default React.memo(Sidebar);

const Menus = props => {
  const { onClickMenuOption } = props;
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [highlightedMenu, setHighlightedMenu] = useState('');

  const renderOverlayContent = () => {
    return (
      <div className={styles.overlayContentContainer}>
        {tooltipOptions.map(tooltip => {
          const { id, type, icon, name, disabled } = tooltip;
          return (
            <div key={`tooltipRow-${id}`} className={styles.tooltipBtnWrapper}>
              <div
                className={classNames({
                  [styles.tooltipItem]: true,
                  [styles.highligthtedStyle]: highlightedMenu === type,
                  [styles.disabledButton]: disabled,
                })}
                onClick={() => {
                  if (!disabled) {
                    onClickMenuOption && onClickMenuOption(type);
                    setTooltipVisible(false);
                  }
                }}
                onMouseEnter={() => setHighlightedMenu(type)}
                onMouseLeave={() => setHighlightedMenu('')}>
                <div className={styles.tooltipImgWrapper}>
                  <img src={icon} className={styles.tooltipMenuIcon} alt='Icon' />
                </div>
                <span className={classNames({ [styles.tooltipTextStyle]: true, [styles.disabledTxt]: disabled })}>{name}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <Tooltip
      placement="bottomLeft"
      visible={tooltipVisible}
      overlay={renderOverlayContent()}
      trigger={"click"}
      overlayInnerStyle={{ padding: "0.93vh" }}
      onVisibleChange={(visible) => setTooltipVisible(visible)}
    >
      <img src={optionIcon} className={styles.imgStyle} alt="menu" />
    </Tooltip>
  );
};

Menus.propTypes = {
  onClickMenuOption: PropTypes.func,
};

Menus.defaultProps = {
  onClickMenuOption: () => { },
};
